import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { space, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { ellipsis } from 'polished';
import { Icon } from '../icon/Icon';
import { Group } from '../group/Group';

const StyledIcon = styled(Icon)`
  margin-right: 4px;
  vertical-align: middle;
`;

const StyledLink = styled.a`
  ${ellipsis()}
  color: ${themeGet('link.color')};
  text-decoration: inherit;
  vertical-align: bottom;
  ${space}
  ${typography}

  &:hover {
    color: ${themeGet('link.hover.color')};
  }

  &:active {
    color: ${themeGet('link.active.color')};
  }

  ${StyledIcon} {
    color: inherit;
  }
`;

const Link = ({ icon, iconSize, href, children, target, ...rest }) => {
  const { link: defaultLinkStyle } = useContext(ThemeContext);
  return (
    <StyledLink rel="noopener" target={target} href={href} {...defaultLinkStyle} {...rest}>
      {icon && <StyledIcon fontSize={iconSize} name={icon} />}
      {children}
    </StyledLink>
  );
};

Link.defaultProps = {
  target: '_blank',
  iconSize: 20,
};

const LinkGroup = styled(Group).attrs({
  itemStyle: { mr: 4 },
})``;

Link.Group = LinkGroup;

export { Link };
